import http from '@/http'

const URL = '/admin/data-integrations'

export const list = () => http.get(URL)
export const show = (id) => http.get(`${URL}/${id}`)
export const save = (payload) => payload.id ? http.put(`${URL}/${payload.id}`, payload) : http.post(URL, payload)
export const remove = (id) => http.delete(`${URL}/${id}`)
export const toggleStatus = (id) => http.put(`${URL}/${id}/status`)
export const triggerSync = (id) => http.post(`${URL}/${id}/sync`)
export const syncLogs = (id, params) => http.get(`${URL}/${id}/logs`, { params })
export const testConnection = (id) => http.post(`${URL}/${id}/test-connection`)
export const getProviders = () => http.get(`${URL}/providers`)
export const getAvailableFields = () => http.get(`${URL}/available-fields`)

export default {
  list,
  show,
  save,
  remove,
  toggleStatus,
  triggerSync,
  syncLogs,
  testConnection,
  getProviders,
  getAvailableFields
}
